document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.c-team-accordion__scroll__header__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            const targetId = this.getAttribute('data-id')
            const menuList = document.querySelector('.c-team-accordion__group[data-id=' + targetId + ']')

            let activeGroup = document.querySelector('.c-team-accordion__group.is-active');
            activeGroup?.classList.remove('is-active');

            let activeBtn = document.querySelector('.c-team-accordion__scroll__header__btn.is-active');
            activeBtn?.classList.remove('is-active');

            this.classList.toggle('is-active')
            menuList.classList.toggle('is-active')
        });
    })

    document.querySelectorAll('.c-jobs-filter__single').forEach(function (jobFilter) {
        jobFilter.addEventListener('click', function (e) {
            document.querySelector('.c-jobs-filter').submit()
        })
    })

})
